import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Facet, StoreProducts } from '../models/catalog.model';

const initialState: StoreProducts = {
  item: undefined,
  products: [],
  facets: { brands: [], priceRange: {} },
  totalProducts: 0,
  isFetching: false,
};

type RefreshProductDetailsPayload = Pick<StoreProducts, 'item' | 'products'>;
type RefreshProductPayload = Pick<StoreProducts, 'products' | 'totalProducts'>;

export const catalogSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    refreshProductsData: (state, action: PayloadAction<RefreshProductPayload>) => {
      state.products = action.payload.products;
      state.totalProducts = action.payload.totalProducts;
    },
    refreshFacetsData: (state, action: PayloadAction<Facet>) => {
      state.facets = action.payload;
    },
    refreshProductDetails: (state, action: PayloadAction<RefreshProductDetailsPayload>) => {
      state.item = action.payload.item;
      state.products = action.payload.products;
    },
    fetchingRefresh: (state, action: PayloadAction<boolean>) => {
      state.isFetching = action.payload;
    },
    resetCatalogStore: () => initialState,
  },
});

export const CatalogSlice = catalogSlice.actions;
export default catalogSlice.reducer;
